import type { FC } from "react";
import React from "react";

import { Spinner } from "@react/ui-primitives/spinner";

export const LoadingView: FC = () => (
  <div className="flex size-full flex-1 items-center justify-center">
    <Spinner className="size-12 text-primary" />
  </div>
);
